import {createContext} from "react";
import {UrlString} from "../Utilities";

const APIContext = createContext(UrlString);

export default APIContext